export default __webpack_public_path__ + "media/Confluence_right.793c896b1bb24f69287da7fb5f4f25da.svg";